export default function AboutSection() {
  return (
    <section id="about" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Section Label */}
        <div className="flex flex-col items-center mb-14">
          <span className="text-yellow-500 text-xs font-bold tracking-widest uppercase mb-3">ABOUT US</span>
          <div className="w-10 h-0.5 bg-yellow-400 mb-6" />
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 text-center leading-snug max-w-2xl">
            平成22年の設立以来、<br />
            企業の可能性を最大限に引き出す
          </h2>
        </div>

        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden w-full h-[360px] md:h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20business%20consultant%20meeting%20with%20clients%20in%20a%20modern%20bright%20office%2C%20discussing%20strategy%20on%20whiteboard%2C%20collaborative%20atmosphere%2C%20natural%20light%2C%20clean%20minimalist%20interior%2C%20Japanese%20corporate%20setting%2C%20warm%20tones&width=800&height=600&seq=about001&orientation=landscape"
                alt="コンサルティングの様子"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Accent Card */}
            <div className="absolute -bottom-6 -right-4 md:-right-8 bg-yellow-400 rounded-xl p-5 shadow-lg">
              <p className="text-gray-900 font-bold text-2xl">2010</p>
              <p className="text-gray-800 text-xs font-medium">年 設立</p>
            </div>
          </div>

          {/* Text */}
          <div className="flex flex-col gap-6 pt-6 lg:pt-0">
            <p className="text-gray-600 text-base leading-relaxed">
              株式会社マスター・マインド・グループは、平成22年4月8日に設立されました。
              私たちは、企業の経営課題に真摯に向き合い、人と組織の可能性を最大限に引き出すパートナーとして歩んできました。
            </p>
            <p className="text-gray-600 text-base leading-relaxed">
              経営コンサルティングを通じて、クライアント企業の持続的な成長と発展を支援します。
              戦略立案から実行支援まで、一貫したサポートを提供することで、確かな成果をお届けします。
            </p>

            {/* Company Info */}
            <div className="bg-white rounded-xl p-6 border border-gray-100">
              <h3 className="text-gray-800 font-semibold text-sm mb-4 tracking-wide">会社基本情報</h3>
              <dl className="flex flex-col gap-3">
                {[
                  { dt: '会社名', dd: '株式会社マスター・マインド・グループ' },
                  { dt: '代表者', dd: '小西　真平' },
                  { dt: '所在地', dd: '〒530-0043 大阪府大阪市北区天満1丁目4-19 キオプラザ天満橋' },
                  { dt: '電話番号', dd: '050-8896-2380' },
                  { dt: 'メール', dd: 'keiri@master-mind-group.com' },
                  { dt: '設立', dd: '平成22年4月8日' },
                  { dt: '事業内容', dd: '経営コンサルティング業務 / SNS運用代行' },
                ].map((item) => (
                  <div key={item.dt} className="flex gap-4 text-sm">
                    <dt className="text-gray-400 w-24 shrink-0">{item.dt}</dt>
                    <dd className="text-gray-700 font-medium">{item.dd}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>


      </div>
    </section>
  );
}
